<template>
  <a-modal
    title="粉丝订单"
    :width="990"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    :bodyStyle="{paddingTop:0}"
  >
    <a-tabs defaultActiveKey="1" v-if="currentRobotId">
      <a-tab-pane tab="淘宝订单" key="1">
        <taobao :currentRobotId="currentRobotId" :uid="funsId" :createdt="createdt"></taobao>
      </a-tab-pane>
      <a-tab-pane tab="京东订单" key="2">
        <jingdong :currentRobotId="currentRobotId" :uid="funsId" :createdt="createdt"></jingdong>
      </a-tab-pane>
      <a-tab-pane tab="拼多多订单" key="3">
        <pinduoduo :currentRobotId="currentRobotId" :uid="funsId" :createdt="createdt"></pinduoduo>
      </a-tab-pane>
      <a-tab-pane tab="唯品会订单" key="4">
        <weipinhui :currentRobotId="currentRobotId" :uid="funsId" :createdt="createdt"></weipinhui>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>

<script>
import FansApi from '@/api/fans'
import Taobao from '@/views/fans/order/taobao'
import Jingdong from '@/views/fans/order/jingdong'
import Pinduoduo from '@/views/fans/order/pinduoduo'
import Weipinhui from '@/views/fans/order/weipinhui'
export default {
  components: {
    Taobao,
    Jingdong,
    Pinduoduo,
    Weipinhui
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      loading: false,
      visible: false,
      currentRobotId: null,
      funsId: null,
      createdt:''
    }
  },
  created() {},
  methods: {
    show({ robotid,uid,createdt }) {
      this.currentRobotId = Number(robotid)
      this.funsId = Number(uid)
      this.createdt=String(createdt)
      this.visible = true
    },
    handleCancel() {
      this.currentRobotId = null
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
</style>
